/* eslint-disable */
export enum BusinessType {
  SUBLIMATION = "Sublimation",
  DIRECT_TO_GARMENT = "Direct to garment",
  SIGNAGE = "Signage",
}
